import { call, put } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { requestContentWhiteboardData } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { loaderDisplayChanged } from 'features/content-library/contentLibrarySlice';

export function* requestContentWhiteboardDataSaga(
  action: ReturnType<typeof requestContentWhiteboardData>
) {
  yield put(loaderDisplayChanged(true));

  const { id, page } = action.payload;

  contentBoard.type = 'file';
  contentBoard.id = id;
  contentBoard.currentPage = page;

  yield call(SignalingSocket.send, {
    event: 'requestContentWhiteboardData',
    data: { id, page },
  });
}
